<div id="applications-list">
  <div
    *ngIf="!areApplicationsLoaded || fileList.length || isFilterOn"
    class="list-table applications placeholder-glow"
    [ngClass]="{
      'show-sorting': responsiveAppsListSortVisible,
      'show-search': responsiveAppsListSearchVisible
    }"
  >
    <ng-container *ngIf="environment.SYSTEM_CODE === 'CO' && fileList.length">
      <div class="top-table-filters-pagination">
        <div class="top-table-filters">
          <label class="search-field-with-icon">
            <span class="visually-hidden" i18n="@@Filter">Filter</span>
            <input
              id="unified-search-filter"
              type="text"
              [(ngModel)]="searchFilter.unified"
              i18n-placeholder="@@Filter"
              placeholder="Filter"
              (ngModelChange)="searchUnified$.next($event)"
            />
            <i class="fa-regular fa-magnifying-glass"></i>
          </label>
        </div>
        <div class="top-table-pagination">
          <pagination-controls
            *ngIf="fileList.length"
            [id]="paginationId"
            class="list-pagination applications"
            [autoHide]="true"
            (pageChange)="onApplicationsPageChange($event)"
            [previousLabel]="globalStateProviderService.previousLabel"
            [nextLabel]="globalStateProviderService.nextLabel"
          ></pagination-controls>
        </div>
      </div>
    </ng-container>
    <div class="heading-container">
      <div
        *ngIf="columns.includes(AvailableFileListColumns.SERVICE_TITLE)"
        class="list-column service-title sortable"
      >
        <button
          type="button"
          i18n="@@parta-my-applications-tab-my-applications-title-service"
          (click)="sortFiles('service__name')"
        >
          Service
        </button>
        <i
          class="sortorder far"
          *ngIf="currentApplicationsOrdering === 'service__name'"
          [ngClass]="{
            'fa-arrow-up': appsListSorting.reverse,
            'fa-arrow-down': !appsListSorting.reverse
          }"
        ></i>
      </div>
      <div
        *ngIf="columns.includes(AvailableFileListColumns.ENTERPRISE_NAME)"
        class="list-column enterprise-name sortable"
      >
        <button
          type="button"
          i18n="@@parta-my-applications-tab-my-applications-title-company"
          (click)="sortFiles('business_entity__name')"
        >
          Business
        </button>
        <i
          class="sortorder far fa-sort-alpha-down"
          *ngIf="currentApplicationsOrdering === 'business_entity__name'"
          [ngClass]="{
            'fa-arrow-up': appsListSorting.reverse,
            'fa-arrow-down': !appsListSorting.reverse
          }"
        ></i>
      </div>
      <div
        *ngIf="columns.includes(AvailableFileListColumns.CREATED_AT)"
        class="list-column date-column sortable"
      >
        <button
          type="button"
          i18n="@@parta-my-applications-tab-my-applications-title-creation"
          (click)="sortFiles('created_at')"
        >
          File creation
        </button>
        <i
          class="sortorder far fa-sort-alpha-down"
          *ngIf="currentApplicationsOrdering === 'created_at'"
          [ngClass]="{
            'fa-arrow-up': appsListSorting.reverse,
            'fa-arrow-down': !appsListSorting.reverse
          }"
        ></i>
      </div>
      <div
        *ngIf="columns.includes(AvailableFileListColumns.SUBMITTED_AT)"
        class="list-column date-column sortable"
      >
        <button
          type="button"
          i18n="@@parta-my-applications-tab-my-applications-title-sent"
          (click)="sortFiles('submitted_at')"
        >
          Sent
        </button>
        <i
          class="sortorder far fa-sort-alpha-down"
          *ngIf="currentApplicationsOrdering === 'submitted_at'"
          [ngClass]="{
            'fa-arrow-up': appsListSorting.reverse,
            'fa-arrow-down': !appsListSorting.reverse
          }"
        ></i>
      </div>
      <div
        *ngIf="columns.includes(AvailableFileListColumns.STATUS)"
        class="list-column reg-status-column sortable"
      >
        <button
          type="button"
          i18n="@@parta-file-registration-statuses"
          (click)="sortFiles('state')"
        >
          Registration status
        </button>
        <i
          class="sortorder far fa-sort-alpha-down"
          *ngIf="currentApplicationsOrdering === 'state'"
          [ngClass]="{
            'fa-arrow-up': appsListSorting.reverse,
            'fa-arrow-down': !appsListSorting.reverse
          }"
        ></i>
      </div>
      <div
        *ngIf="columns.includes(AvailableFileListColumns.CERTIFICATE)"
        class="list-column results-column"
      >
        <span>
          <span i18n="@@parta-file-results">Results</span>
          <i
            class="far fa-question-circle"
            i18n-tooltip="@@parta-file-results-tooltip"
            tooltip="Results tooltip"
          ></i>
        </span>
      </div>
      <div
        *ngIf="columns.includes(AvailableFileListColumns.ACTIONS)"
        class="list-column actions-column"
      >
        <button
          type="button"
          class="far fa-filter show-hide-filters"
          (click)="
            isApplicationsHeadingFiltersVisible =
              !isApplicationsHeadingFiltersVisible
          "
          i18n-tooltip="@@Toggle filters"
          tooltip="Toggle filters"
        ></button>
      </div>
    </div>
    <div class="filters-container" *ngIf="isApplicationsHeadingFiltersVisible">
      <ng-container *ngIf="environment.SYSTEM_CODE !== 'CO'">
        <div class="list-column service-title">
          <label>
            <span class="visually-hidden" i18n="@@Filter services"
              >Filter services</span
            >
            <input
              id="service-filter-input"
              type="text"
              [(ngModel)]="searchFilter.service"
              i18n-placeholder="@@Filter services"
              placeholder="Filter services"
              (ngModelChange)="searchService$.next($event)"
            />
          </label>
        </div>
        <div class="list-column enterprise-name">
          <label>
            <span class="visually-hidden" i18n="@@Filter companies"
              >Filter companies</span
            >
            <input
              id="company-filter-input"
              type="text"
              [(ngModel)]="searchFilter.company"
              i18n-placeholder="@@Filter companies"
              placeholder="Filter companies"
              (ngModelChange)="searchCompany$.next($event)"
            />
          </label>
        </div>
      </ng-container>
    </div>
    <div class="responsive-sort-filter">
      <div class="btn-group dropdown responsive-sort">
        <button
          i18n="@@Sort by"
          type="button"
          class="btn btn-secondary"
          *ngIf="currentApplicationsOrdering === ''"
        >
          Sort by
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          *ngIf="currentApplicationsOrdering === 'service__name'"
          (click)="sortFiles('service__name')"
          i18n-tooltip="@@Change sort order"
          tooltip="Change sort order"
        >
          <span i18n="@@Service">Service</span>
          <i
            class="sortorder far fa-sort-alpha-down"
            [ngClass]="{ 'fa-sort-alpha-down-alt': appsListSorting.reverse }"
          ></i>
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          *ngIf="currentApplicationsOrdering === 'business_entity__name'"
          (click)="sortFiles('business_entity__name')"
          i18n-tooltip="@@Change sort order"
          tooltip="Change sort order"
        >
          <span i18n="@@Business">Business</span>
          <i
            class="sortorder far fa-sort-alpha-down"
            [ngClass]="{ 'fa-sort-alpha-down-alt': appsListSorting.reverse }"
          ></i>
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          *ngIf="currentApplicationsOrdering === 'created_at'"
          (click)="sortFiles('created_at')"
          i18n-tooltip="@@Change sort order"
          tooltip="Change sort order"
        >
          <span i18n="@@Creation time">Creation time</span>
          <i
            class="sortorder far fa-sort-alpha-down"
            [ngClass]="{ 'fa-sort-alpha-down-alt': appsListSorting.reverse }"
          ></i>
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          *ngIf="currentApplicationsOrdering === 'submitted_at'"
          (click)="sortFiles('submitted_at')"
          i18n-tooltip="@@Change sort order"
          tooltip="Change sort order"
        >
          <span i18n="@@Submission time">Submission time</span>
          <i
            class="sortorder far fa-sort-alpha-down"
            [ngClass]="{ 'fa-sort-alpha-down-alt': appsListSorting.reverse }"
          ></i>
        </button>
        <button
          type="button"
          class="btn btn-secondary dropdown-toggle hide-default-toggler-icon"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i class="fal fa-filter"></i>
        </button>
        <ul class="dropdown-menu">
          <li>
            <a
              i18n="@@Service"
              class="dropdown-item"
              (click)="sortFiles('service__name')"
              >Service</a
            >
          </li>
          <li>
            <a
              i18n="@@Business"
              class="dropdown-item"
              (click)="sortFiles('business_entity__name')"
              >Business</a
            >
          </li>
          <li>
            <a
              i18n="@@Creation time"
              class="dropdown-item"
              (click)="sortFiles('created_at')"
              >Creation time</a
            >
          </li>
          <li>
            <a
              i18n="@@Submission time"
              class="dropdown-item"
              (click)="sortFiles('submitted_at')"
              >Submission time</a
            >
          </li>
        </ul>
      </div>
      <div class="dropdown responsive-filter">
        <button
          type="button"
          class="dropdown-toggle hide-default-toggler-icon"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="fal fa-search"></i>
          <span i18n="@@Search">Search</span>
        </button>
        <div class="dropdown-menu">
          <div>
            <label>
              <span class="visually-hidden" i18n="@@Filter services"
                >Filter services</span
              >
              <input
                id="responsive-service-filter-input"
                type="text"
                [(ngModel)]="searchFilter.service"
                i18n-placeholder="@@Filter services"
                placeholder="Filter services"
                (ngModelChange)="searchService$.next($event)"
              />
            </label>
          </div>
          <div>
            <label>
              <span class="visually-hidden" i18n="@@Filter companies"
                >Filter companies</span
              >
              <input
                id="responsive-company-filter-input"
                type="text"
                [(ngModel)]="searchFilter.company"
                i18n-placeholder="@@Filter companies"
                placeholder="Filter companies"
                (ngModelChange)="searchCompany$.next($event)"
              />
            </label>
          </div>
        </div>
      </div>
    </div>
    <div #applicationsList class="list-container placeholder">
      <div
        class="list-item"
        *ngFor="
          let f of (limitedView ? limitedFileList : fileList)
            | paginate
              : {
                  id: paginationId,
                  itemsPerPage: 10,
                  currentPage: currentApplicationsPage,
                  totalItems: totalFilesCount
                };
          let i = index
        "
        [ngClass]="
          'status-' + f.rowCssClass + ' file-state-' + f.fileState_code
        "
        style="--listIndex: {{ i }}"
      >
        <div
          *ngIf="columns.includes(AvailableFileListColumns.SERVICE_TITLE)"
          class="list-column service-title"
          (click)="showFileProcessing(f)"
        >
          <span
            i18n-tooltip
            tooltip="{{ f.getFileStateTranslated(f.fileState) }}"
            placement="right"
            class="service-title-column-text"
            >{{ f.service_name }}</span
          >
        </div>
        <div
          *ngIf="columns.includes(AvailableFileListColumns.ENTERPRISE_NAME)"
          class="list-column enterprise-name"
          (click)="showFileProcessing(f)"
        >
          <span i18n="@@Business" class="responsive-label">Business</span>
          <span>{{
            (f.data && f.data['listing-value']) ||
              f.metadata ||
              f.business_entity_name ||
              '-'
          }}</span>
        </div>
        <div
          *ngIf="columns.includes(AvailableFileListColumns.CREATED_AT)"
          class="list-column date-column"
          (click)="showFileProcessing(f)"
        >
          <span i18n="@@Creation time" class="responsive-label"
            >Creation time</span
          >
          <span class="date-value">{{ f.created_at | date: DATE_FORMAT }}</span>
        </div>
        <div
          *ngIf="columns.includes(AvailableFileListColumns.SUBMITTED_AT)"
          class="list-column date-column"
          (click)="showFileProcessing(f)"
        >
          <span i18n="@@Submission time" class="responsive-label"
            >Submission time</span
          >
          <span class="date-value">{{
            f.submitted_at | date: DATE_FORMAT
          }}</span>
        </div>
        <div
          *ngIf="columns.includes(AvailableFileListColumns.STATUS)"
          class="list-column reg-status-column"
        >
          <span i18n="@@Status" class="responsive-label">Status</span>
          <div class="dropdown status-list-dropdown" dropdown>
            <a
              dropdownToggle
              class="dropdown-toggle status-{{ f.rowCssClass }}"
            >
              <span>{{ f.getFileStateTranslated(f.fileState) }}</span>
              <i class="far fa-ellipsis-v" *ngIf="f.fileState !== 'Draft'"></i>
            </a>
            <ul
              *dropdownMenu
              class="dropdown-menu dropdown-menu-end"
              [hidden]="!f.tasks?.length"
            >
              <li
                *ngFor="let task of f.tasks | keepLatestUniqueInstanceWithName"
              >
                <app-task-status [task]="task"></app-task-status>
              </li>
            </ul>
          </div>
        </div>
        <div
          *ngIf="columns.includes(AvailableFileListColumns.CERTIFICATE)"
          class="list-column results-column"
        >
          <span i18n="@@Results" class="responsive-label">Results</span>
          <a
            *ngIf="f.certificates.length && f.certificates.length === 1"
            (click)="docPreviewModal(f)"
            placement="left"
            tooltip="{{ f.certificates[0].document_name }}"
          >
            <i class="far fa-file-alt"></i>
          </a>
          <div
            *ngIf="f.certificates.length && f.certificates.length > 1"
            class="dropdown multiple-results"
          >
            <button
              type="button"
              class="dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="far fa-file-alt"></i>
              <i class="far fa-file-alt"></i>
            </button>
            <div class="dropdown-menu">
              <a
                *ngFor="let certificate of f.certificates; index as i"
                (click)="docPreviewModal(f, i)"
                >{{ certificate.document_name }}</a
              >
            </div>
          </div>
        </div>
        <div
          *ngIf="columns.includes(AvailableFileListColumns.ACTIONS)"
          class="list-column actions-column"
          [ngSwitch]="f.fileState_code"
        >
          <div *ngSwitchCase="'draft'">
            <a
              class="edit"
              placement="left"
              i18n-tooltip="@@parta-file-edit"
              tooltip="Edit file"
              (click)="showFileProcessing(f)"
            >
              <i class="fal fa-pencil"></i>
            </a>
            <a
              *ngIf="f.isDeletable"
              class="trash"
              placement="top"
              #popover="bs-popover"
              [popover]="deleteTemplate"
              popoverTitle="Confirmation"
              i18n-popoverTitle="@@Confirmation"
              triggers="click"
              (click)="registerPopover(f.file_id, popover)"
            >
              <i class="fal fa-trash-alt"></i>
            </a>
            <ng-template #deleteTemplate>
              <p
                i18n="@@Do you want to delete this file?"
                class="popover-body-text"
              >
                Do you want to delete this file?
              </p>
              <div class="popover-buttons">
                <button
                  class="btn btn-primary btn-danger btn-sm"
                  (click)="deleteFile(f); hidePopover(f.file_id)"
                  i18n="Delete file"
                >
                  Delete file
                </button>
                <button
                  class="btn btn-secondary btn-sm"
                  (click)="hidePopover(f.file_id)"
                  i18n="Cancel"
                >
                  Cancel
                </button>
              </div>
            </ng-template>
          </div>
          <div *ngSwitchCase="'pending'">
            <a
              class="review hide"
              placement="left"
              i18n-tooltip="@@Review file"
              tooltip="Review file"
              (click)="showFileProcessing(f)"
            >
              <fa-icon [icon]="faSearch"></fa-icon>
            </a>
          </div>
          <div *ngSwitchCase="'action_required'">
            <a
              class="edit"
              placement="left"
              i18n-tooltip="@@parta-file-edit"
              tooltip="Edit file"
              (click)="showFileProcessing(f)"
            >
              <i class="fal fa-pencil"></i>
            </a>
          </div>
          <div *ngSwitchCase="'applicantPayment'">
            <a
              class="edit"
              placement="left"
              i18n-tooltip="@@parta-file-edit"
              tooltip="Edit file"
              (click)="showFileProcessing(f)"
            >
              <i class="fal fa-pencil"></i>
            </a>
          </div>
          <div *ngSwitchCase="'to_correct'">
            <a
              class="edit"
              placement="left"
              i18n-tooltip="@@parta-file-edit"
              tooltip="Edit file"
              (click)="showFileProcessing(f)"
            >
              <i class="fal fa-pencil"></i>
            </a>
          </div>
          <div *ngSwitchCase="'rejected'">
            <a
              class="review hide"
              placement="left"
              i18n-tooltip="@@Review file"
              tooltip="Review file"
              (click)="showFileProcessing(f)"
            >
              <i class="far fa-search"></i>
            </a>
          </div>
          <div *ngSwitchCase="'closed'">
            <a
              class="review hide"
              placement="left"
              i18n-tooltip="@@Review file"
              tooltip="Review file"
              (click)="showFileProcessing(f)"
            >
              <i class="far fa-search"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="noResults$ | async" class="no-results">
    <div i18n="@@No applications" class="system-message info">
      No applications
    </div>
    <div class="actions">
      <a
        *ngIf="!hideListOfServices"
        i18n="@@Apply for service"
        href="#services-list-anchor"
        class="btn btn-primary btn-md"
        >Apply for service</a
      >
    </div>
  </div>
  <div *ngIf="noFilteredResults$ | async" class="no-match-results">
    <div i18n="@@No matching files" class="system-message info">
      No matching files
    </div>
    <div class="actions">
      <button
        i18n="@@Reset filters"
        (click)="resetFilters()"
        class="btn btn-primary btn-md"
      >
        Reset filters
      </button>
      <a
        *ngIf="!hideListOfServices"
        i18n="@@Apply for service"
        href="#services-list-anchor"
        class="btn btn-secondary btn-md"
        >Apply for service</a
      >
    </div>
  </div>
  <ng-container *ngIf="environment.SYSTEM_CODE !== 'CO'">
    <pagination-controls
      *ngIf="!limitedView && fileList.length"
      [id]="paginationId"
      class="list-pagination applications"
      [autoHide]="true"
      (pageChange)="onApplicationsPageChange($event)"
      [previousLabel]="globalStateProviderService.previousLabel"
      [nextLabel]="globalStateProviderService.nextLabel"
    ></pagination-controls>
  </ng-container>

  <div
    *ngIf="fileList.length || isFilterOn"
    class="status-legend-filter"
    [ngClass]="{
      'limited-list': limitedView && fileList.length > 3,
      'no-limited-button': fileList.length <= 3
    }"
  >
    <button
      type="button"
      class="all-limited-button"
      (click)="toggleLimitedView()"
      *ngIf="fileList.length > 3"
    >
      <span *ngIf="limitedView"
        ><ng-container i18n="@@view all files">View all files</ng-container>
        <i class="far fa-angle-down"></i
      ></span>
      <span *ngIf="!limitedView"
        ><ng-container i18n="@@limited view">Limited view</ng-container>
        <i class="far fa-angle-up"></i
      ></span>
    </button>
    <div class="status-legend-list" [ngClass]="{ 'show-legend': showLegend }">
      <span i18n="@@file-list-filter-by-status-text" class="status-legend-label"
        >Filter by status text</span
      >
      <button
        type="button"
        i18n="@@file-list-popover-labels-text-3-1"
        class="status-default"
        [ngClass]="{ 'active-filter': currentApplicationsFilter === 'NEW' }"
        (click)="getUserFiles({ state: 'NEW' })"
      >
        Draft
      </button>
      <button
        type="button"
        i18n="@@file-list-popover-labels-text-2-1"
        class="status-info"
        [ngClass]="{
          'active-filter': currentApplicationsFilter === 'filepending'
        }"
        (click)="getUserFiles({ state: 'filepending' })"
      >
        Pending
      </button>
      <button
        type="button"
        i18n="@@file-list-popover-labels-text-1-1"
        class="status-success"
        [ngClass]="{
          'active-filter': currentApplicationsFilter === 'filevalidated'
        }"
        (click)="getUserFiles({ state: 'filevalidated' })"
      >
        Processed
      </button>
      <button
        type="button"
        i18n="@@file-list-popover-labels-text-4-1"
        class="status-warning"
        [ngClass]="{
          'active-filter': currentApplicationsFilter === 'filedecline'
        }"
        (click)="getUserFiles({ state: 'filedecline' })"
      >
        Action required
      </button>
      <button
        type="button"
        i18n="@@file-list-popover-labels-text-5-1"
        class="status-danger"
        [ngClass]="{
          'active-filter': currentApplicationsFilter === 'filereject'
        }"
        (click)="getUserFiles({ state: 'filereject' })"
      >
        Rejected
      </button>
    </div>
    <button
      type="button"
      i18n="@@status-filter"
      class="status-legend-toggler"
      *ngIf="!showLegend"
      (click)="showLegend = !showLegend"
    >
      Status filter
    </button>
    <button
      type="button"
      *ngIf="showLegend"
      class="far fa-times legend-info-icon"
      (click)="showLegend = !showLegend"
    ></button>
  </div>
</div>
